import { Box, Typography, InputBase, IconButton, Button, Instagram, InsertLinkOutlinedIcon, CloseIcon, AddCircleOutlineOutlinedIcon } from "src/components";

export default function UserSocialMediaEditor({ instagramHandle, socialMediaLinks, onChangeInstagram, onChangeLinks, size="small" }) {
  const titleSize = size === "small" ? "body2" : "subtitle1";
  const textSize = size === "small" ? "body3" : "body2";
  const iconSize = size === "small" ? 18 : 22;

  return (
    <Box>
      <Typography variant={titleSize} fontWeight={600}>Social Media Links</Typography>

      <Box display="flex" flexDirection="column" width="100%">
        <Box sx={{display: 'flex', gap: 1, mt: 1, mb: 1, alignItems: 'center', height: '20px'}}>
          <Instagram sx={{color: 'text.secondary', width: iconSize, height: iconSize}} />
          <Typography variant={titleSize} color="text.disabled" fontWeight={400} sx={{ userSelect: 'none' }}>
            instagram.com/
          </Typography>
          <InputBase
            placeholder="your_handle"
            value={instagramHandle || ""}
            onChange={(e) => onChangeInstagram(e.target.value)}
            sx={(theme) => ({
              ...theme.typography[titleSize],
              flex: 1,
              height: '20px'
            })}
          />
        </Box>

        {socialMediaLinks.map((url, index) => (
          <Box key={index} sx={{display: 'flex', gap: 1, alignItems: 'center'}}>
            <InsertLinkOutlinedIcon sx={{color: 'text.secondary', width: iconSize, height: iconSize}} />
            <InputBase
              fullWidth
              placeholder="https://your-social-link.com"
              value={url}
              onChange={(e) => {
                const updated = [...socialMediaLinks];
                updated[index] = e.target.value;
                onChangeLinks(updated);
              }}
              sx={(theme) => ({ ...theme.typography[titleSize], flex: 1, height: '25px'})}
            />

            {socialMediaLinks.length > 1 && (
              <IconButton
                disableRipple
                onClick={() => {
                  const updated = socialMediaLinks.filter((_, i) => i !== index);
                  onChangeLinks(updated);
                }}>
                <CloseIcon sx={{width: 16, height: 16}} />
              </IconButton>
            )}
          </Box>
        ))}

        {socialMediaLinks.length < 4 && (
          <Button
            onClick={() => onChangeLinks([...socialMediaLinks, ""])}
            startIcon={<AddCircleOutlineOutlinedIcon />}
            sx={{ alignSelf: "flex-start", alignItems: 'center', mt: 1 }}
            size="small"
          >
            <Typography variant={textSize} fontWeight={600}>Add Another</Typography>
          </Button>
        )}
      </Box>
    </Box>
  );
}
